export default __webpack_public_path__ + "static/media/buildings_desktop.f5cb90d2.png";